'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/inherits");

var EventEmitter = require('events').EventEmitter;

var pull = require('pull-stream');

var handshake = require('pull-handshake');

var constants = require('./constants');

var util = require('./util');

var rnd = util.rnd;

var debug = require('debug');

var log = debug('libp2p-ping');
log.error = debug('libp2p-ping:error');
var PROTOCOL = constants.PROTOCOL;
var PING_LENGTH = constants.PING_LENGTH;

var Ping =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(Ping, _EventEmitter);

  function Ping(swarm, peer) {
    var _this;

    _classCallCheck(this, Ping);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Ping).call(this));
    _this._stopped = false;
    _this.peer = peer;
    _this.swarm = swarm;
    return _this;
  }

  _createClass(Ping, [{
    key: "start",
    value: function start() {
      var _this2 = this;

      log('dialing %s to %s', PROTOCOL, this.peer.id.toB58String());
      this.swarm.dial(this.peer, PROTOCOL, function (err, conn) {
        if (err) {
          return _this2.emit('error', err);
        }

        var stream = handshake({
          timeout: 0
        });
        _this2.shake = stream.handshake;
        pull(stream, conn, stream); // write and wait to see ping back

        var self = _this2;

        function next() {
          var start = new Date();
          var buf = rnd(PING_LENGTH);
          self.shake.write(buf);
          self.shake.read(PING_LENGTH, function (err, bufBack) {
            var end = new Date();

            if (err || !buf.equals(bufBack)) {
              var _err = new Error('Received wrong ping ack');

              return self.emit('error', _err);
            }

            self.emit('ping', end - start);

            if (self._stopped) {
              return;
            }

            next();
          });
        }

        next();
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this._stopped || !this.shake) {
        return;
      }

      this._stopped = true;
      pull(pull.empty(), this.shake.rest());
    }
  }]);

  return Ping;
}(EventEmitter);

module.exports = Ping;